 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~9a7cfb37","1":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~f1a6f51d","2":"source~/esports-betting-rules-TR~esports-betting-rules-AZ~esports-betting-rules-DA~esports-betting-r~c810e73c","4":"source~virtual-esports-betting-rules-AZ~virtual-esports-betting-rules-EN~virtual-esports-betting-rul~8df6e383","8":"source~bet-details-page~betting-history-page","9":"source~i18n-widgets-en-json","10":"source~i18n-widgets-ro-json","11":"source~i18n-widgets-ru-json","12":"source~i18n-widgets-tr-json","15":"source~/esports-betting-rules-TR","16":"source~bet-builder-rules-AZ","17":"source~bet-builder-rules-DE","18":"source~bet-builder-rules-EN","19":"source~bet-builder-rules-ES","20":"source~bet-builder-rules-ES-MX","21":"source~bet-builder-rules-ET","22":"source~bet-builder-rules-FI","23":"source~bet-builder-rules-FR","24":"source~bet-builder-rules-IT","25":"source~bet-builder-rules-JA","26":"source~bet-builder-rules-KA","27":"source~bet-builder-rules-LT","28":"source~bet-builder-rules-LV","29":"source~bet-builder-rules-PL","30":"source~bet-builder-rules-PT-BR","31":"source~bet-builder-rules-RO","32":"source~bet-builder-rules-RU","33":"source~bet-builder-rules-SQ","34":"source~bet-builder-rules-SV","35":"source~bet-builder-rules-TR","36":"source~bet-details-page","37":"source~betting-history-container","38":"source~betting-history-page","39":"source~betting-rules-AZ","40":"source~betting-rules-DA","41":"source~betting-rules-DE","42":"source~betting-rules-EN","43":"source~betting-rules-ES","44":"source~betting-rules-ES-MX","45":"source~betting-rules-FR","46":"source~betting-rules-IT","47":"source~betting-rules-JA","48":"source~betting-rules-PL","49":"source~betting-rules-PT","50":"source~betting-rules-PT-BR","51":"source~betting-rules-RO","52":"source~betting-rules-RU","53":"source~betting-rules-SQ","54":"source~betting-rules-SV","55":"source~betting-rules-TR","56":"source~bonus-info","57":"source~cashout-terms-AR","58":"source~cashout-terms-AZ","59":"source~cashout-terms-DA","60":"source~cashout-terms-DE","61":"source~cashout-terms-EN","62":"source~cashout-terms-ES","63":"source~cashout-terms-ES-MX","64":"source~cashout-terms-ET","65":"source~cashout-terms-FI","66":"source~cashout-terms-FR","67":"source~cashout-terms-IT","68":"source~cashout-terms-JA","69":"source~cashout-terms-KA","70":"source~cashout-terms-KU","71":"source~cashout-terms-LT","72":"source~cashout-terms-LV","73":"source~cashout-terms-PL","74":"source~cashout-terms-PT","75":"source~cashout-terms-PT-BR","76":"source~cashout-terms-RO","77":"source~cashout-terms-RU","78":"source~cashout-terms-SQ","79":"source~cashout-terms-SR","80":"source~cashout-terms-SV","81":"source~cashout-terms-TR","82":"source~esports-betting-rules-AZ","83":"source~esports-betting-rules-DA","84":"source~esports-betting-rules-DE","85":"source~esports-betting-rules-EN","86":"source~esports-betting-rules-ES","87":"source~esports-betting-rules-ES-MX","88":"source~esports-betting-rules-ET","89":"source~esports-betting-rules-FI","90":"source~esports-betting-rules-FR","91":"source~esports-betting-rules-IT","92":"source~esports-betting-rules-JA","93":"source~esports-betting-rules-KA","94":"source~esports-betting-rules-LT","95":"source~esports-betting-rules-LV","96":"source~esports-betting-rules-PL","97":"source~esports-betting-rules-PT","98":"source~esports-betting-rules-PT-BR","99":"source~esports-betting-rules-RO","100":"source~esports-betting-rules-RU","101":"source~esports-betting-rules-SQ","102":"source~esports-betting-rules-SR","103":"source~esports-betting-rules-SV","105":"source~generated-mappings","106":"source~i18n-en-json","107":"source~i18n-ro-json","108":"source~i18n-ru-json","109":"source~i18n-tr-json","111":"source~settings-page","112":"source~streaming-carousel","113":"source~virtual-esports-betting-rules-AZ","114":"source~virtual-esports-betting-rules-EN","115":"source~virtual-esports-betting-rules-IT","116":"source~virtual-esports-betting-rules-JA","117":"source~virtual-esports-betting-rules-PL","118":"source~virtual-esports-betting-rules-RU","120":"vendors~rc-slider","121":"vendors~react-google-recaptcha","122":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"c9125d054817a822ae79","1":"a2cd55cd5c4cbf02b489","2":"f69e0e59ecd01f0d5ff3","3":"003f2202d33ef315126c","4":"df31b6611bb7351dc65b","5":"44ce1ed32f68cff4b2be","6":"e281aa21d79c08902ec3","8":"70b74465262f9c35cb7c","9":"6a0ad1a8e9f67567e983","10":"fcfd27faaecb957f4cd5","11":"3b292260f0a55b3ebb93","12":"227ef4ff15b4b26ea343","15":"db62621b0dda9f8c9625","16":"99366af7f51b1e26508e","17":"21f0e503e8d467b8e3ae","18":"249f7cf15743cc811d86","19":"6678f342920ecc1ebf21","20":"940597969bfa7bcd3b7d","21":"7055c874db83fac7d0c9","22":"f11002a2830f475a06e1","23":"885dce87a22fc0ecbdd6","24":"abead016dc4bf4303cb3","25":"6c68dcdc17d1551c6503","26":"1682292565271d2f0318","27":"3552ddedf76b6ab02a1b","28":"636819d33b7de92ab2ad","29":"4a332f6ee31ad4167e95","30":"8c279c8ff09f9b6134b2","31":"fa86b1b146f740f4a5de","32":"716e15a5fec506d9a722","33":"9f988c5797b18d6790ce","34":"d816e5c52d4b45614c79","35":"2e0bd7aa5b6feff9e111","36":"599e6a379186c58f7250","37":"5f2426c8fdd6f736a8c5","38":"81a60afb0eda867df603","39":"a3ab63cb5494de36638d","40":"7b919e0b2e94708c0aed","41":"099896d2ae53ffc599aa","42":"f61707590d1fe856844c","43":"e07123e7e206a663b3fc","44":"1defeb65772163f4019b","45":"e532fffd6326c1f7b22b","46":"0c61c18a945c9173bc06","47":"b122b4b4ca126d56d319","48":"6e2581339696c37226a3","49":"2b73dca5db23722b5934","50":"8ae168b9346fcf8f4c04","51":"c74a71a8261b9406ca72","52":"58d691fb1d493485a06e","53":"8896d52c759fd5f4276e","54":"350c9c6fa7ede2f6de1d","55":"ea4c4417fb78ac032f4b","56":"386c4a1bcbf1b704b079","57":"b5655d84a793df0b237a","58":"499649fc764b7ed9a296","59":"d0ff852cb5579c8633a0","60":"8711ca70513927c1a582","61":"8c67f8e67629107b3b67","62":"833be8e9569719b8dc65","63":"4d87dc2d135fc922f40c","64":"069c13377efb385a46d3","65":"8e8909e63ed2e4eda179","66":"207b7e59937183b2caa4","67":"e36c5ca02d134999c575","68":"38f710d76468e06b8978","69":"3408a223275a0a4ed7e3","70":"5f24cbb9fdee91803b8a","71":"a866f678e680c5276e8c","72":"2097b44dacd7f17fd5a8","73":"8f34ac3e0239d892fdc3","74":"ede6322755db454df006","75":"be7bdf5f5dd7974fcb92","76":"defcade6151a11def9ba","77":"ead0d39e5bdbb8db8ce6","78":"30485f2f6d468216fc45","79":"4bdeb9004138b9ce6546","80":"a375a9b40885f2dda04c","81":"0745b004d1d1d978e639","82":"5408e34c7a0878164095","83":"5a5ba48b349437155f3c","84":"b0ca46e907307679c72b","85":"47603100b4d3f8b70cac","86":"90dc6dae3fd871c4b79d","87":"77871abbcee93dccbf59","88":"5d216c410662707a3007","89":"d021b9b931dfe0338f44","90":"dae910acc9b9b258f229","91":"a330bc182ebff823c68e","92":"c748843d792dc06bf8d6","93":"65c75d4d55d358cf96f2","94":"d0b97f6dc2bd8ce63717","95":"6fc6fd68fc13497547d2","96":"374c9bae3ccd6f8a4765","97":"fd6d3e995443b4f23741","98":"84d06b3b424adadaa7db","99":"bc360460f6d407a357f0","100":"adab36a2261ba81ddf97","101":"8d7060a4125a70de215a","102":"310de447418401b54a0e","103":"e5eea73167a249e8679e","105":"291bfb13511b695b07e3","106":"1614e4ec31b97f6bc996","107":"8a53cfd80bb3c829ef95","108":"079c44935eba1f51d638","109":"5e95eae1b844784ea169","111":"fdabd40d340ff01b5300","112":"928aa566553cd87480c5","113":"456e5d46b90f53cf1020","114":"5f6a7fab6b90b5ec6fed","115":"fcb291a5e546b4f9f2af","116":"cae24620c89206ac99f3","117":"c37b245cd007261645d3","118":"203688ca6e949fd11c33","120":"de0abe3afee6ebc2ef7d","121":"78222ca8ea7510ee53f4","122":"958578c480257dab8361","123":"c378c1076a4950208a58","124":"d3d138a26eefcf462b2c","125":"c961299ed026b9adaa14","126":"af4dc495b1780b94e336","127":"f6427a1396a64ff07bc7","128":"5049e9b7902512fae51e","129":"f9f53bca2c2bf9223bbc","130":"74d6eb854b10ffc28ffd","131":"95cf473f357ce64f57d5","132":"e76e2331e74272eb553e","133":"edf0873455b23eebb7f1","134":"6a4965669f80487f7088","135":"025ba66ea72844bc315f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
